<template>
  <div id="qr">
    <div class="deviceAddBlock">
      <el-form id="deviceAdd" ref="deviceAdd" size="small" label-position="top">
        <div class="formContentQR">
          <el-form-item class="radio">
            <label>{{$t("qr.qrset")}}</label>
            <el-select size="small" v-model="curSettings.qr_type" class="elselect" :placeholder="$i18n.t('qr.qrset_0')">
              <el-option key="op1" :label="$i18n.t('qr.qrset_1')" value="1"></el-option>
              <el-option key="op2" :label="$i18n.t('qr.qrset_2')" value="2"></el-option>
              <el-option key="op3" :label="$i18n.t('qr.qrset_3')" value="3"></el-option>
              <el-option v-if="lang!='en'" key="op4" :label="$i18n.t('qr.qrset_4')" value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="curSettings.qr_type==1" class="radio uploadblock">
            <label>{{$t("qr.qrupload")}}:</label>
            <el-upload
              class="avatar-uploader"
              action="/fileSvr/put"
              name="name"
              :data="{ app_name: 'conf_app' }"
              :show-file-list="false"
              :on-success="handleAvatarSuccessQr"
              :before-upload="beforeAvatarUploadQr"
            >
              <div v-if="curSettings.qr_static">
                <img :src="curSettings.qr_static.indexOf('http')==0?curSettings.qr_static: ('/fileSvr/get/' + curSettings.qr_static)" class="avatar avatar_qr" />
              </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item v-if="curSettings.qr_type==3" class="radio">
            <label>{{$t("qr.apimodel")}}</label>
            <el-select size="small" v-model="curSettings.qr_url.api_type" class="elselect" :placeholder="$i18n.t('qr.apimodel_1')">
              <el-option key="op1" :label="$i18n.t('qr.apimodel_1')" value="1"></el-option>
              <el-option key="op2" :label="$i18n.t('qr.apimodel_2')" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="curSettings.qr_type==3" class="radio">
            <label>
              <span class="must">*</span>
              {{$t("qr.qrapi")}}:
            </label>
            <el-input
              class="textinput"
              size="small"
              v-model="curSettings.qr_url.url"
              :placeholder="$i18n.t('qr.qrapi')"
            ></el-input>
          </el-form-item>

          <el-form-item v-if="curSettings.qr_type==3 && curSettings.qr_url.api_type==2" class="radio">
            <label>
              <span class="must">*</span>
              {{$t("qr.qrlink")}}:
            </label>
            <el-input
              class="textinput"
              size="small"
              v-model="curSettings.qr_url.qr_keys"
              :placeholder="$i18n.t('qr.qrlink')"
            ></el-input>
          </el-form-item>

          <el-form-item v-if="curSettings.qr_type==4" class="radio">
            <label>
              <span class="must">*</span>APP_ID:
            </label>
            <el-input
              class="textinput_short"
              size="small"
              v-model="curSettings.qr_app_id"
              :placeholder="$i18n.t('qr.wxapi')"
            ></el-input>
            <el-button class="rightbtn" v-if="curSettings.qr_app_id" type="primary" @click="wxAuth">{{$t("qr.wx_auth_btn")}}</el-button>
          </el-form-item>

          <el-form-item class="radio subimtitem">
            <el-button class="btn1 btn4qr" type="primary" @click="submit">{{$t("normal_sure")}}</el-button>
            <el-button
              class="btn1 btn4qr btn4qr2"
              type="primary"
              @click="resetDefault"
            >{{$t("resetdefault")}}</el-button>
          </el-form-item>

          <el-form-item v-if="curSettings.qr_type==3 && api_result" class="radio">
            <label>{{$t("qr.testapi")}}:</label>
            <div  class="showQrDemo" style="width:100%;height:auto">
              <span>{{$t("qr.testapitips")}}</span>
              <br />
              <label v-if="api_result.qr">{{$t("qr.qrimage")}}:</label>
              <label></label>
              <img v-if="api_result.qr" :src="api_result.qr" style="width:100px;height:100px;" />
              <span style="color:red;padding-left: 1.35rem;" v-else>{{$t("qr.getqrlinkfail")}}</span>
              <br />
              <label v-if="api_result.qr">{{$t("qr.imagelink")}}:</label>
              <span v-if="api_result.qr" class="textShowM" style="height:30px;font-size:9px;word-break: break-all;word-wrap: break-word;">{{api_result.qr}}</span>
              <br />
              <label v-if="api_result.api_return">{{$t("qr.jsonresult")}}:</label>
              <br />
              <div
                v-if="api_result.api_return"
                class="textShowM"
                style="height:60px;padding-left: 1.2rem;word-break: break-all;word-wrap: break-word;"
              >{{api_result.api_return}}</div>
            </div>
          </el-form-item>

        </div>

        <div class="tips">
          <div class="tipsArticle" v-if="curSettings.qr_type==1" v-html="helps.qr_for_upload_image"></div>
          <div class="tipsArticle" v-if="curSettings.qr_type==2" v-html="helps.qr_h5"></div>
          <div class="tipsArticle" v-if="curSettings.qr_type==3" v-html="helps.qr_for_api"></div>
          <div class="tipsArticle" v-if="curSettings.qr_type==4" v-html="helps.qr_for_wx"></div>
        </div>

      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "qr",
  data() {
    return {
      doing: false,
      curSettings: {},
      helps: {},
      api_result: null,
	  lang: this.$i18n.locale
    };
  },
  computed: {},
  watch: {
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    wxAuth() {
        if (!this.curSettings.qr_app_id ||this.curSettings.qr_app_id === "") {
            this.$message(this.$i18n.t("qr.qr_upload_tips"));
            return false;
        }
        this.axios
            .get("/userSrv/wxThirdEvent/getAuthPage/"+this.curSettings.wx_third.key+"?biz_appid="+this.curSettings.qr_app_id)
            .then(function(response) {
                if (response.data.code === 0) {
                    window.open(response.data.auth_page)
                }
            });
    },
    getList() {
      if (this.doingc === true) {
        return false;
      }
      this.doingc = true;
      let _this = this;
      let data = {
        code: 'qr_type,qr_static,qr_url,qr_app_id'
      };
      this.axios
        .post("/skinMgrSrv/config/get", this.formData(data))
        .then(function(response) {
          _this.doingc = false;
          if (response.data.code === 0) {
              let cur  = response.data
              if(!cur.qr_url){
                  cur.qr_url={}
              }
              _this.helps = cur.helps
              delete cur.helps;
              _this.curSettings = cur
              console.log(response.data);
          }
        });
    },
    submit() {
      if (this.doing === true) {
        return false;
      }
      let qrType =parseInt(this.curSettings.qr_type)
      let params = {qr_type: qrType}
      if(qrType === 1){
          if (!this.curSettings.qr_static ||this.curSettings.qr_static === "") {
              this.$message(this.$i18n.t("qr.qr_upload_tips"));
              return false;
          }
          params.qr_static = this.curSettings.qr_static
      }else if(qrType === 3){
          if (!this.curSettings.qr_url || this.curSettings.qr_url.length ==0 ||!this.curSettings.qr_url.url||this.curSettings.qr_url.url==="") {
              this.$message(this.$i18n.t("qr.qr_api_tips"));
              return false;
          }
          if(this.curSettings.qr_url.api_type&&parseInt(this.curSettings.qr_url.api_type) === 2&&(!this.curSettings.qr_url.qr_keys || this.curSettings.qr_url.qr_keys==="")){
              this.$message(this.$i18n.t("qr_link_tips"));
              return false;
          }
          if(!this.curSettings.qr_url.api_type){
              this.curSettings.qr_url.api_type ='1'
          }
          params.qr_url = JSON.stringify(this.curSettings.qr_url)
      }else if(qrType === 4){
          if (!this.curSettings.qr_app_id ||this.curSettings.qr_app_id === "") {
              this.$message(this.$i18n.t("qr.qr_upload_tips"));
              return false;
          }
          params.qr_app_id = this.curSettings.qr_app_id
      }
      this.doing = true;
      let _this = this;
      _this.api_result = null;
      this.axios
        .post("/skinMgrSrv/config/update", this.formData(params))
        .then(function(response) {
          _this.doing = false;
          if (qrType === 3) {
              _this.api_result = response.data.api_result
          }
          if (response.data.code === 0) {
            _this.$message(_this.$i18n.t("qr.setsuccess"));
            _this.getList();
          } else {
            _this.$message(_this.$i18n.t("qr.setfail"));
          }
          console.log(response.data);
        });
    },
    handleAvatarSuccessQr(res, file) {
      if (res.code == 10000) {
        this.$set(this.curSettings,'qr_static',res.img_path)
      }
    },
    beforeAvatarUploadQr(file) {
      const isJPG = file.type === "image/jpeg";
      const isPng = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        this.$message.error(this.$i18n.t("image_fix_tips"));
      }
      if (!isLt2M) {
        this.$message.error(this.$i18n.t("image_big_tips_2"));
      }
      return (isJPG || isPng) && isLt2M;
    },
    resetDefault() {
      this.doing = true;
      let _this = this;
      let params = {qr_type: ''}
      this.axios
        .post("/skinMgrSrv/config/update", this.formData(params))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code === 0) {
              _this.$message(_this.$i18n.t("qr.setsuccess"));
              _this.getList();
          } else {
              _this.$message(_this.$i18n.t("qr.setfail"));
          }
          console.log(response.data);
        });
    },
    getUserInfo() {
      var _this = this;
      _this.getList();
    }
  }
};
</script>
<style  lang="scss">
#qr {
  .tabs-container {
    .el-card__header {
      padding: 0.0833rem 0.1667rem !important;
    }
    .el-card {
      cursor: pointer;
    }
    .el-card:hover {
      border: $blue 1px solid;
    }
  }
  .el-dialog__header {
    border-bottom: #e9e9e9 1px solid !important;
  }
  .el-button--primary {
    color: #fff;
    background-color: #57AEC9;
    border-color: #57AEC9;
  }
  .el-tabs__item.is-active {
    color: #57AEC9;
  }
  .el-tabs__active-bar {
    background-color: #57AEC9;
  }
  .el-tabs__header {
    margin: 0 0 0.5rem;
  }
  .avatar-uploader,
  .el-upload,
  .el-upload--text {
    width: 1.22rem;
    height: 1.22rem;
    display: inline-block;
  }
  .avatar-uploader-icon {
    border: 1px solid #ccc;
  }
  .must {
    color: #57AEC9;
  }
  .tipsArticle {
    color: #666;
    width: 5rem;
    height: auto;
    line-height: 180%;
    strong {
      color: #57AEC9;
    }
    h2 {
      font-size: 0.15rem;
      line-height: 180%;
    }
    p {
      font-size: 0.1rem;
      line-height: 180%;
    }
    img {
      width: 100%;
      border: 1px solid #ccc;
      border-radius: 10px;
    }
  }
}
</style>
<style scoped lang="scss">
#qr {
  padding: 0.1667rem;
  box-sizing: border-box;
  p.title {
    height: 0.4167rem;
    line-height: 0.4167rem;
    font-size: 0.15rem;
    color: #000;
  }
  .deviceAddBlock {
    width: 100%;
    min-height: 4rem;
    height: auto;
    border-radius: 0.04166rem;
    display: block;
    #deviceAdd {
      width: calc(100% - 0.3rem);
      height: 100%;
      margin: 0.1667rem 0.14166rem 0.5833rem;
      display: inline-block;
      .formContent,
      .formContentQR {
        vertical-align: top;
        display: inline-block;
        height: auto;
        width: 4.3rem;
        min-height: 4rem;
        text-align: left;
        .smalltips {
          width: 1.8rem;
          height: auto;
          float: right;
          color: #999;
          font-size: 0.1rem;
          text-align: left;
          padding-left: 0.08rem;
        }
      }
      .formContentQR {
        width: 6.5rem;
        margin-top: 0.167rem;
        margin-right: 0.1rem;
      }
      .tips {
        vertical-align: top;
        display: inline-block;
        width: 4rem;
        height: auto;
        vertical-align: top;
        margin-top: 0.167rem;
        .tipsBlock {
          border: 1px solid #ffcee5;
          border-radius: 0.04rem;
          background-color: #fff8fb;
          color: #57AEC9;
          width: 3rem;
          height: auto;
          font-size: 0.1rem;
          padding-left: 0.1rem;
          padding-bottom: 0.06rem;
          h2 {
            margin-top: 0.1rem;
          }
          .tipsText {
            margin-top: 0.06rem;
            line-height: 180%;
          }
        }
        .tipsBlockQR {
          width: 3.8rem;
        }
        .logoimagetips {
          font-size: 0.1rem;
          color: #57AEC9;
          margin: 0.05rem 0;
        }
        .logotipsImage {
          width: 1.6rem;
          height: 2.82rem;
          background-image: url(../assets/img/logo4tips.png);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
        .tipsforqr {
          background-image: url(../assets/img/qrcodetips.png);
        }

        .tipsImage {
          width: 6rem;
          height: 3.5rem;
          background-image: url(../assets/img/tips4.png);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
        .textShowM {
          height: 1.7rem;
          line-height: 0.25rem;
          background-color: #fff;
          display: inline-block;
          padding: 0px 0.08rem;
          border-radius: 0.04rem;
          width: 5.5rem;
          color: #8d8f91;
          border: 1px solid #d9d9d9;
          font-size: 0.116rem;
          img {
            widows: 3rem;
          }
        }
      }
    }
    background-color: #fff;
  }
  label {
    display: inline-block;
    width: 1.8rem;
    height: auto;
    float: left;
    text-align: right;
    margin-right: 0.1667rem;
    font-size: 0.116rem;
  }
  label.forlogo {
    width: 0.8rem;
  }
  .textinput {
    width: 3.5rem;
  }
  .textinput_short {
    width: 2.5rem;
  }
  .textShow {
    height: 0.25rem;
    line-height: 0.25rem;
    background-color: #ddd;
    display: inline-block;
    padding: 0px 0.08rem;
    border-radius: 0.04rem;
    width: 3.35rem;
    font-size: 0.116rem;
  }
  .elselect {
    width: 2.5rem;
  }
  .btn1 {
    margin-left: 0.96rem;
    width: 1rem;
  }

  .rightbtn {
    margin-left: 0.1rem;
    width: 0.5rem;
  }

  .btn4qr {
    margin-left: 1.35rem;
  }
  .btn4qr2 {
    margin-left: 0.1rem;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 1.22rem;
    height: 1.22rem;
    margin-left: 128px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    color: #8c939d;
    width: 1.22rem;
    height: 1.22rem;
    text-align: center;
    line-height: 1.22rem;
    margin-top: 0.08rem;
  }
  .avatar_qr {
    height: 1.22rem;
    margin-top: 0.06rem;
  }
  .uploadblock {
    min-height: 1.22rem;
  }
  .subimtitem {
    margin-top: 0.25rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/config/qr.vue